import axiosClient from './axiosClient';
export default {
  list: (params) => axiosClient.get('/contribuenti', { params }),
  listnotassociated: (params) => axiosClient.get('/contribuenti/notassociatedtouser', { params }),
  liststudioassociable: (params) => axiosClient.get('/contribuenti/associabili', { params }),
  listbystudio: (studioId, params) => axiosClient.get(`/contribuenti/bystudioid/${studioId}`, { params }),
  get: (id) => axiosClient.get(`/contribuenti/${id}`),
  getMyContribuente: () => axiosClient.get('/contribuenti/me'),
  getbyuserid: (userId) => axiosClient.get(`/contribuenti/byuserid/${userId}`),
  create: (data) => axiosClient.post('/contribuenti', data),
  update: (id, data) => axiosClient.put(`/contribuenti/${id}`, data),
  delete: (id) => axiosClient.delete(`/contribuenti/${id}`),
  uploadDocumento: (id, formData) => axiosClient.post(`/contribuenti/${id}/documenti/upload`, formData, { headers: {'Content-Type': 'multipart/form-data'} }),
};